module.exports = __webpack_public_path__ + "img/video-placeholder-NM.b6abd38b.jpg";